import { render, staticRenderFns } from "./OsParticipantForm.vue?vue&type=template&id=519076c8&scoped=true"
import script from "./OsParticipantForm.vue?vue&type=script&lang=ts"
export * from "./OsParticipantForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519076c8",
  null
  
)

export default component.exports